/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BinderFilterQueryDto
 */
export interface BinderFilterQueryDto {
    /**
     * 
     * @type {string}
     * @memberof BinderFilterQueryDto
     */
    searchText?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BinderFilterQueryDto
     */
    countries?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BinderFilterQueryDto
     */
    status?: BinderFilterQueryDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BinderFilterQueryDto
     */
    businessLine?: string;
    /**
     * 
     * @type {string}
     * @memberof BinderFilterQueryDto
     */
    principalOccupation?: string;
    /**
     * 
     * @type {Date}
     * @memberof BinderFilterQueryDto
     */
    authorityStartDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BinderFilterQueryDto
     */
    authorityEndDate?: Date;
}


/**
 * @export
 */
export const BinderFilterQueryDtoStatusEnum = {
    Active: 'Active',
    Upcoming: 'Upcoming',
    Expired: 'Expired'
} as const;
export type BinderFilterQueryDtoStatusEnum = typeof BinderFilterQueryDtoStatusEnum[keyof typeof BinderFilterQueryDtoStatusEnum];


/**
 * Check if a given object implements the BinderFilterQueryDto interface.
 */
export function instanceOfBinderFilterQueryDto(value: object): value is BinderFilterQueryDto {
    return true;
}

export function BinderFilterQueryDtoFromJSON(json: any): BinderFilterQueryDto {
    return BinderFilterQueryDtoFromJSONTyped(json, false);
}

export function BinderFilterQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BinderFilterQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'searchText': json['searchText'] == null ? undefined : json['searchText'],
        'countries': json['countries'] == null ? undefined : json['countries'],
        'status': json['status'] == null ? undefined : json['status'],
        'businessLine': json['businessLine'] == null ? undefined : json['businessLine'],
        'principalOccupation': json['principalOccupation'] == null ? undefined : json['principalOccupation'],
        'authorityStartDate': json['authorityStartDate'] == null ? undefined : (new Date(json['authorityStartDate'])),
        'authorityEndDate': json['authorityEndDate'] == null ? undefined : (new Date(json['authorityEndDate'])),
    };
}

export function BinderFilterQueryDtoToJSON(json: any): BinderFilterQueryDto {
    return BinderFilterQueryDtoToJSONTyped(json, false);
}

export function BinderFilterQueryDtoToJSONTyped(value?: BinderFilterQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'searchText': value['searchText'],
        'countries': value['countries'],
        'status': value['status'],
        'businessLine': value['businessLine'],
        'principalOccupation': value['principalOccupation'],
        'authorityStartDate': value['authorityStartDate'] == null ? undefined : ((value['authorityStartDate']).toISOString()),
        'authorityEndDate': value['authorityEndDate'] == null ? undefined : ((value['authorityEndDate']).toISOString()),
    };
}

